import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { take } from 'rxjs/operators';
import { ContenusService } from 'src/app/services/contenus.service';
import { HistoriqueService } from 'src/app/services/historique.service';
import { ModerationService } from 'src/app/services/moderation.service';

@Component({
  selector: 'app-visualisation',
  templateUrl: './visualisation.component.html',
  styleUrls: ['./visualisation.component.css']
})
export class VisualisationComponent implements OnInit {

  idModeration:number;

  infoPtl = {
    dateArrivee : "",
    enseigne : "",
    etat: "",
    complexite : "",
    loginPtl : "",
    typePtl: "",
    idBonPlan : "",
  };

  listeContenus:any = [];

  contenuCols = [
    {field: 'designation_type', header: 'Type contenu'},
    {field: 'valeur_contenu', header: 'Valeur'}
  ]

  constructor(private activatedRoute:ActivatedRoute, private moderationService:ModerationService, private contenusService:ContenusService) { }

  ngOnInit(): void {

    this.getParams()

    .then((moderation:number) => {
      this.idModeration = moderation;
      return this.moderationService.getDetailsPtl(this.idModeration).pipe(take(1)).toPromise();
    })

    .then((resultsRequestDetails:any) => {
      console.log(resultsRequestDetails);
      
      if(resultsRequestDetails.status && resultsRequestDetails.status === "success"){
        let data = resultsRequestDetails.data;
        this.infoPtl = {
          loginPtl : data.num_point_accueil,
          idBonPlan : data.id_bon_plan,
          complexite : data.libelle_complexite,
          dateArrivee : data.date_arrivee,
          enseigne : data.enseigne_guide,
          etat : data.etat,
          typePtl : data.type_ptl
        };
      } else {
        console.log(resultsRequestDetails.cause);
      }
      return this.contenusService.recupererContenusCq(this.idModeration).pipe(take(1)).toPromise();
    })

    .then((resultsRequestContenus:any) => {
      if(resultsRequestContenus.status && resultsRequestContenus.status === "success"){
        let data = resultsRequestContenus.data;
        this.listeContenus = data;
      } else {
        console.log(resultsRequestContenus.cause);
      }
    })

    .catch((err) => {
      console.log(err);
    });
  }

  getParams(){
    return new Promise((resolve, reject) => {

      this.activatedRoute.params.pipe(take(1)).toPromise()

      .then((params: Params) => {
        resolve(params.moderation);
      })

      .catch((err) => {
        console.log("Erreur lors de la recuperation des parametres")
        reject(err);
      });

    });
  }

  
}
